/** Static PDF in `public/` (regenerated on prebuild). CRA `homepage` is relative (`"."`). */
const base = String(process.env.PUBLIC_URL || "").replace(/\/$/, "");
export const CLAIM_REWARDS_PERMISSION_GUIDE_PDF_URL = `${base}/nftrewards_claimrewards_permission_guide_v1.pdf`;
export const CLAIM_REWARDS_PERMISSION_GUIDE_DOWNLOAD_NAME = "nftrewards_claimrewards_permission_guide_v1.pdf";
